import {WIDGET_STEP__SELECT_SPEC_OR_DOCTOR} from "@/plugins/consts"

export const step = {
  state: {
    step: WIDGET_STEP__SELECT_SPEC_OR_DOCTOR,
  },
  mutations: {
    setStep(state, val) {
      state.step = val
    }
  },
  getters: {
    step(state) {
      return state.step
    }
  }
}